import React from 'react';

/**
 * Textarea - Dark-aware multiline text input primitive.
 *
 * Companion to Input. Same styling contract: base classes first, caller
 * `className` appended so individual utilities can be overridden. All native
 * props (value, onChange, rows, placeholder, disabled, ref, ...) pass through.
 *
 * @param {Object} props
 * @param {string} props.className - Additional CSS classes (override base)
 */
const BASE =
  'w-full px-3 py-2 rounded-lg border transition-colors ' +
  'bg-white text-gray-900 border-gray-300 placeholder-gray-400 ' +
  'dark:bg-slate-800 dark:text-slate-100 dark:border-slate-600 dark:placeholder-slate-400 ' +
  'focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ' +
  'disabled:opacity-60 disabled:cursor-not-allowed';

const Textarea = React.forwardRef(({ className = '', ...props }, ref) => (
  <textarea ref={ref} className={`${BASE} ${className}`.trim()} {...props} />
));

Textarea.displayName = 'Textarea';

export default Textarea;
